// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2QZj3","content":"ManualTimeModal_content__2eI4j"};